module.exports = __webpack_public_path__ + "assets/img/rxsa1.a7ff9617.png";